import React from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import OptionIcon from "./OptionIcon";

/**
 * Special predefined choice question (e.g., yesno, multi smiley, bodyparts)
 * @param {string} type - The type of the question (e.g., yes/no)
 * @param {Object} options - The multiple choice options
 * @param {string} options.type - The type of the option (e.g., yes)
 */
function StaticChoice({ type, options, onMouseDownHandler = () => {} }) {
  return (
    <Grid container spacing={2} paddingLeft={1} paddingTop={2}>
      {options.map((option, index) => (
        <Grid key={option.id} item xs={12}>
          <Box
            display="flex"
            alignItems="center"
            sx={{ gap: 1, cursor: "default" }}
          >
            <Box
              onClick={(event) => {
                event.stopPropagation();
                onMouseDownHandler(`${option.id}number`);
              }}
            >
              <OptionIcon type={type} option={option} index={index} />
            </Box>
            <Typography
              color="textSecondary"
              variant="body2"
              onClick={(event) => {
                event.stopPropagation();
                onMouseDownHandler(`${option.id}title`);
              }}
              sx={{ width: "100%" }}
            >
              {option.title}
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}

export default StaticChoice;
